module.exports = __webpack_public_path__ + "b878e78da25217513272533982cd5b0d.png";


//////////////////
// WEBPACK FOOTER
// ./client/components/imgs/login-logo.png
// module id = 92
// module chunks = 0